import React from 'react'

import { Box, Text } from '@vividseats/vivid-ui-kit'
import classNames from 'classnames'
import CountUp from 'react-countup'
import { InView } from 'react-intersection-observer'

import styles from '../styles.module.scss'

interface ValueContainerProps {
    value: number
    text: string
    suffix: string
    textClassName?: string
}

export const ValueContainer: React.FC<ValueContainerProps> = ({ value, text, suffix, textClassName }) => {
    const mergedClassName = classNames(styles.text, textClassName)

    return (
        <Box flexDirection="column" className={styles.valueBox}>
            <InView triggerOnce>
                {({ inView, ref }) => (
                    <div ref={ref}>
                        <CountUp
                            start={inView ? 0 : undefined}
                            end={value}
                            duration={1}
                            separator=","
                            suffix={suffix}
                            className={styles.value}
                        />
                    </div>
                )}
            </InView>

            <Text className={mergedClassName} altFont={true}>
                {text}
            </Text>
        </Box>
    )
}
